/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_Allow_ApplicationInputs */



/**
* | output |
* | --- |
* | "This will allow the application to:" |
*
* @param {Oauth_Allow_ApplicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_allow_application = /** @type {((inputs?: Oauth_Allow_ApplicationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Allow_ApplicationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela permettra à l'application de :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto permitirá a la aplicación:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Isso permitirá que o aplicativo:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo permetterà all'applicazione di:")
	return /** @type {LocalizedString} */ ("This will allow the application to:")
});